import { Center, Spinner } from "@chakra-ui/react";
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { useQuery } from "react-query";
import { getStatsProgress } from "../../../services/partnerApi";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  indexAxis: "y",
  elements: {
    bar: {
      borderWidth: 2,
    },
  },
  responsive: true,
  plugins: {
    legend: {
      display: false,
      position: "right",
    },
    title: {
      display: false,
      text: "Chart.js Horizontal Bar Chart",
    },
  },
  scales: {
    x: {
      ticks: {
        color: "#FFFFFF",
      },
    },
    y: {
      ticks: {
        color: "#FFFFFF",
      },
    },
  },
};

const labels = ["0-10%", "10-25%", "25-50%", "50-75%", "75-99%", "100%"];

export const chartData = {
  labels,
  datasets: [
    {
      label: "Number of readers",
      data: [10, 8, 5, 7, 3, 2],
      borderColor: "#ae1508",
      backgroundColor: "#ae1508",
    },
    // {
    //   label: "Dataset 2",
    //   data: [-7, -5, 4, 3, 2, -1, 0],
    //   borderColor: "rgb(53, 162, 235)",
    //   backgroundColor: "rgba(53, 162, 235, 0.5)",
    // },
  ],
};

export function ProgressChart() {
  const { data, isLoading, isError, isSuccess } = useQuery("progress", () => {
    return getStatsProgress();
  });

  if (isLoading) {
    return (
      <Center p="3">
        <Spinner color="red" />
      </Center>
    );
  }

  if (isError) {
    return <Center p="3">An error ocurred</Center>;
  }

  if (isSuccess && data.data.length === 0) {
    return <Center p="3">No data yet</Center>;
  }

  return <Bar options={options} data={chartData} />;
}
